import { resolveImage, getBrand } from "@/data/catalog";

export default function ProductImage({ product, className = "", showStamp = true }) {
  const src = resolveImage(product?.images?.[0]);
  if (src) {
    return <img src={src} alt={product.name} loading="lazy" className={`h-full w-full object-contain ${className}`} />;
  }
  const brand = getBrand(product?.brandSlug);
  return (
    <div
      data-testid="product-image-placeholder"
      className={`relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 to-slate-100 ${className}`}
      aria-label="Technical specification preview"
    >
      <div className="bp-grid absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-sky-300/30" />
        <div className="absolute left-0 top-1/2 h-px w-full -translate-y-1/2 bg-sky-300/30" />
      </div>
      <div className="relative flex flex-col items-center gap-2 px-4 text-center">
        <img src="/logo.png" alt="" className="h-12 w-12 object-contain opacity-90" />
        {brand?.name && (
          <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-500">{brand.name}</span>
        )}
        <span className="font-mono text-xs font-bold tracking-tight text-slate-700">{product?.model}</span>
      </div>
      {showStamp && (
        <span className="absolute bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-sm border border-sky-200 bg-white/85 px-2 py-0.5 font-mono text-[9px] font-semibold uppercase tracking-[0.2em] text-sky-700 backdrop-blur">
          Spec sheet · Image pending
        </span>
      )}
    </div>
  );
}
